import type { Course } from "~/models/course";
import CourseItem from "./course-item";


interface Props{
    courses: Course[] | null;
}

export default function CoursesGrid({ courses }: Props){
    //This is added as a sanity check, should never be called. Just incase I use
    //this component elsewhere without the proper data
    if(!courses || courses.length === 0)
        throw new Response("No courses found", {
            status: 404,
            statusText: "No courses found",
            headers: { "Content-Type": "text/plain" }
        });

    return(
        courses?.map(course => (
            <CourseItem course={course} key={course.id} />
        ))
    )
}